// extracted by mini-css-extract-plugin
export default {"email":"vtoxkj"};